const vi = {
    Common: {
        CODE: "Mã",
        SAVE: "Lưu",
        NEXT: "Tiếp tục",
        APPLY: "Áp dụng",
        GO_BACK: "Trở về",
        ACTION: "Thao tác",
        DETAIL: "Chi tiết",
        DISPLAY: "Hiển thị",
        CLOSE: "Đóng",
        APPROVE: "Chấp thuận",
        ACTIVE: "Hoạt động",
        ACTIVED: "Đang hoạt động",
        NO_DATA: "Không có dữ liệu",
        IN_ACTIVE: "Ngưng hoạt động",
        DELETE: "Xóa",
        EDIT: "Chỉnh sửa",
        ADD_NEW: "Thêm mới",
        STATUS: "Trạng thái",
        CREATE_NEW: "Tạo mới",
        SEND: "Gửi",
        VIEW_ALL: "Xem tất cả",
        VIEW_DETAIL: "Xem chi tiết",
        LOAD_MORE: "Xem thêm",
        REMOVE_FROM_SERVICE: "Xóa khỏi dịch vụ",
        CANCEL: "Hủy",
        ACCEPT: "Chấp nhận",
        LOCKED: "Đã bị khóa",
        DELETED: "Đã xóa",
        DRAFT: "Nháp",
        REJECT: "Từ chối",
        REJECTED: "Đã từ chối",
        ACCEPTED: "Đã chấp nhận",
        INVITING: "Đang mời",
        EXPIRED: "Đã hết hạn",
        CHANGE_STATUS: "Thay đổi trạng thái",
        PENDING: "Đang chờ",
        PENDING_INVITATION: "Chờ xác nhận lời mời",
        WARNING_OWNER: "Bạn không có quyền cập nhật quyền này",
        FILTER: "LỌC",
        RESET: "Hủy lọc",
        SEARCH: "Tìm kiếm",
        SELECT: "Chọn",
        CANCEL_SELECT: "Bỏ chọn",
        FILTER_LIST: "Lọc danh sách",
        SELECTED_RECORD: "Đã chọn {0} bảng ghi",
        LABEL_DISPLAY_ROWS: "{0} - {1} trên {2}",
        SEQUENCE: "STT",
        REQUIRED: "Trường dữ liệu là bắt buộc",
        NOT_PERMISSION: "Rất tiếc, bạn không có quyền truy cập",
        PLEASE_COMPLETE_ALL_INFORMATION: "Vui lòng kiểm tra lại thông tin yêu cầu",
        ERROR: "Đã có phát sinh lỗi trong quá trình xử lý, vui lòng thử lại sau. Xin lỗi vì đã gây bất tiện.",
        CANCEL_ACTION_MESSAGE: "Thông tin chỉnh sửa chưa được lưu. Bạn chắc chắn muốn rời khỏi màn hình hiện tại không?",
        EMAIL_ADDRESS: "Sai định dạng email",
        WRONG_PHONE_NUMBER: "Sai định dạng số điện thoại",
        INVALID_TIME: "Thời gian không hợp lệ",
        MALE: "Nam",
        FEMALE: "Nữ",
        OTHER: "Khác",
        UPDATE: "Cập nhật",
        ADD_OR_REMOVE: "Chỉnh sửa",
        ADD_RESOURCES: "Thêm tính năng",
        ALL: "Tất cả",
        INVALID_EMAIL: "Email không hợp lệ",
        DEFAULT: "Mặc định",
        MULTI_LANGUAGE: "Đa ngôn ngữ",
        VI: "Tiếng Việt",
        EN: "Tiếng Anh",
        CONTINUE: "Tiếp tục",
        PAUSE: "Tạm ngừng",
        YES: "Yes",
        NO: "No",
        NOTIFICATION: "Thông báo",
        DROP_FILES_HERE: "Kéo thả hoặc click chọn nhiều file",
        UPLOAD_FILE_FROM_LOCAL: "Tải lên từ máy tính",
        UPLOAD_FILE_FROM_URL: "Nhập URL",
        CHANGE: "Thay đổi",
        ENTER_FILE_URL: "Nhập tên file",
        TOTAL: "Tổng",
        UPLOAD_FILE_ERROR: "Tải file lên không thành công",
        INVALID_FILE: "File không hợp lệ",
        PREVIEW: "Xem trước",
        IMAGE: "Ảnh",
        VIDEO: "Video",
        DOCUMENT: "Tài liệu",
        DOWNLOAD: "Tải xuống",
        FILE_SIZE_MUST_SMALLER_THAN: "Kích thước file phải nhỏ hơn {0}",
        VIDEO_MUST_BE_MP4_FORMAT: "Video phải là định dạng mp4",
        CANCEL_UPLOAD_VIDEO: "Bạn có muốn hủy tải lên video này?",
        UPLOAD_VIDEO_FAILED: "Tải video lên không thành công",
        CANCEL_UPLOAD_IMAGE: "Bạn có muốn hủy tải lên hình ảnh này?",
        UPLOAD_IMAGE_FAILED: "Tải ảnh lên không thành công",
        UPLOAD_VIDEO: "Tải video lên",
        REPLACE: "Thay thế",
        CHOOSE_IMAGE: "Chọn ảnh",
        COMPLETE: "Hoàn thành",
        PLEASE_SELECT_AN_ORGANIZATION: "Vui lòng chọn tổ chức",
        SKIP: "Bỏ qua",
        UNDER_MANAGEMENT: "Thuộc quản lý",
        EMAIL_ALREADY_EXISTS: "Email đã tồn tại",
        LOADING_PDF: "Đang tải PDF",
        LOAD_PDF_ERROR: "Đã xảy ra lỗi khi mở PDF",
        PAGE: "Trang",
        ZOOM_IN: "Phóng to",
        ZOOM_OUT: "Thu nhỏ",
        REMOVE: "Xóa",
        UPLOAD: "Tải lên",
        DRAG_AND_DROP_FILES_HERE_OR_CLICK: "Kéo và thả tập tin vào đây hoặc nhấp vào",
        HTML_EDITOR_CONTENT_ERROR: "Kích cỡ nội dung quá lớn. Bạn có thể chọn hình ảnh bằng thanh công cụ để giảm bớt kích cỡ",

        //
        LOGOUT: "Đăng xuất",
        DO_NOT_CHOOSE: "Không chọn",
        ACCOUNT_INFO: "Thông tin tài khoản",
        STAFF: "Thành viên",
        GROUP: "Nhóm",
        ORGANIZATION: "Tổ chức",
        ADVANCE: "Nâng cao",
        NORMAL: "Cơ bản",
        SELECTED: "Đã chọn",
        COPY: "Sao chép",
    },

    Languages: {
        VIETNAM: "Viet Nam",
        VI: "Tiếng việt",
        EN: "Tiếng anh",
    },

    MESSAGE: {
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa?",
        DELETE_SUCCESS: "Xóa vai trò thành công",
        CONFIRM_CHANGE_STATUS: "Bạn có chắc chắn muốn thay đổi trạng thái?",
        CREATE_SUCCESS: "Tạo vai trò mới thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin vai trò thành công",
        UPDATE_STATUS_SUCCESS: "Cập nhật trạng thái thành công",
    },

    Role: {
        BASIC_INFO: "Vai trò",
        SEARCH_TEXT: "Tìm kiếm theo tên",
        ENTER_SEARCH_TEXT: "Nhập tên vai trò",
        CODE: "Mã vai trò",
        NAME_ROLE: "Tên",
        ENTER_NAME_ROLE: "Nhập tên",
        DESCRIPTION: "Mô tả",
        ENTER_DESCRIPTION: "Nhập mô tả",
        SHOW: "Hiển thị",
        SERVICE_NAME: "Dịch vụ",
        SELECT_SERVICE: "Chọn dịch vụ",
        RESOURCE: "Tính năng",
        ROLE: "Vai trò",
        READ: "Xem",
        VIEW_DETAIL: "Xem chi tiết",
        READ_LIST: "Xem danh sách",
        CREATE: "Tạo",
        BULK_CREATE: "Tạo nhiều",
        UPDATE: "Chỉnh sửa",
        BULK_UPDATE: "Chỉnh sửa nhiều",
        DELETE: "Xóa",
        BULK_DELETE: "Xóa nhiều",
        IMPORT: "Nhập dữ liệu",
        EXPORT: "Xuất dữ liệu",
        NONE: "Không",
        OWNER: "Toàn quyền",
        MANAGER: "Quản lý",
        TYPE: "Loại quyền hạn",
        SELECT_TYPE: "Chọn loại quyền hạn",
        NORMAL: "Normal",
        DEFAULT_ROLE: "Default",
        SERVICE_ROLE: "Service Role",
        MEMBER: "Member",
        OWNER_ROLE: "Organization Owner",
        ORGANIZATION_ADMIN: "Organization Admin",
        GROUP_ADMIN_ROLE: "Group admin",
        SERVICE_ADMIN: "Service Admin",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa vai trò này?",
        DELETE_SUCCESS: "Xóa vai trò thành công",
        CONFIRM_CHANGE_STATUS: "Bạn có chắc chắn muốn thay đổi trạng thái?",
        CREATE_SUCCESS: "Tạo vai trò mới thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin vai trò thành công",
        UPDATE_STATUS_SUCCESS: "Cập nhật trạng thái thành công",
    },

    Organization: {
        MANAGEMENT_ORGANIZATIONS: "Quản lý {0}",
        ADD_ORGANIZATIONS: "Thêm {0}",
        ADD_STAFF: "Thêm {0}",
        ADD_GROUP: "Thêm {0}",
        BASIC_INFO: "Thông tin {0}",
        SEARCH_TEXT: "Tìm kiếm theo tên {0}",
        ENTER_SEARCH_TEXT: "Nhập tên {0}",
        CODE: "Mã {0}",
        NAME: "Tên {0}",
        ENTER_NAME: "Nhập tên {0}",
        PHONE_NUMBER: "Số điện thoại",
        ENTER_PHONE_NUMBER: "Nhập số điện thoại",
        EMAIL: "Email",
        ENTER_EMAIL: "Nhập Email",
        FAX_NUMBER: "Số Fax",
        ENTER_FAX_NUMBER: "Nhập số fax",
        TAX_NUMBER: "Mã số thuế",
        ENTER_TAX_NUMBER: "Nhập mã số thuế",
        WEBSITE: "Website",
        ENTER_WEBSITE: "Nhập địa chỉ website",
        DESCRIPTION: "Mô tả",
        ENTER_DESCRIPTION: "Mô tả",
        IMAGE_PHOTO: "Ảnh {0}",
        OWNER: "Chủ {0}",
        ADD_OWNER: "Chỉ định chủ sở hữu {0}",
        EMAIL_OWNER: "Email chủ sở hữu",
        ENTER_EMAIL_OWNER: "Nhập email cần chỉ định chủ sở hữu {0}",
        TOTAL_STAFF: "Số {0}",
        TOTAL_GROUP: "Số {0}",
        SELECT_STATUS: "Chọn trạng thái",
        DELETE_SUCCESS: "Xóa {0} thành công!",
        CREATE_SUCCESS: "Tạo {0} mới thành công thành công!",
        UPDATE_SUCCESS: "Cập nhật thông tin {0} thành công!",
        CONFIRM_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái hoạt động?",
        CONFIRM_IN_ACTIVE_STATUS: "Bạn chắc chắn muốn chuyển sang trạng thái ngưng hoạt động?",
        IN_ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang ngưng hoạt động thành công!",
        ACTIVE_STATUS_SUCCESS: "Cập nhật trạng thái sang hoạt động thành công!",
        CONFIRM_REMOVE_SERVICE: "Bạn có thực sự muốn xóa {0} này?",
        CONFIRM_CHANGE_OWNER: "Bạn chắc chắn muốn thay đổi chủ {0} mới?",
    },

    Group: {
        BASIC_INFO: "Thông tin {0}",
        SEARCH_TEXT: "Tìm kiếm theo tên {0}",
        SEARCH_PLACEHOLDER: "Nhập tên {0}",

        CODE_GROUP: "Mã {0}",
        GROUP_PARENT: "{0} cấp trên",
        SELECT_GROUP_PARENT: "Chọn {0} cấp trên",
        NAME_GROUP: "Tên {0}",
        ENTER_NAME_GROUP: "Nhập tên {0}",
        CHILD_NUMBER: "{0} trực thuộc",
        CONFIRM_DELETE_WHEN_HAVE_CHILD_GROUP: "Nếu bạn xóa {0} này thì các {1} trực thuộc sẽ đồng loạt bị xóa theo. Bạn có chắc chắn muốn xóa không?",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa {0} này?",
        CREATE_SUCCESS: "Tạo {0} mới thành công!",
        UPDATE_SUCCESS: "Cập nhật thông tin {0} thành công!",
        DELETE_SUCCESS: "Xóa {0} thành công!",

        TITLE_CREATE: "Tạo mới {0}",
        TITLE_DETAIL: "Chi tiết {0}",
        TITLE_UPDATE: "Cập nhật {0}",

        CONFIRM_USER_BY_GROUP_DELETE: "Bạn chắc chắn muốn xóa {0} này khỏi {1} này?",
        DELETE_USER_BY_GROUP_SUCCESS: "Đã xóa {0} khỏi {1} thành công!",
        CREATE_USER_BY_GROUP_SUCCESS: "Đã thêm {0} vào {1} thành công!",
    },

    Staff: {
        TITLE_LIST_VIEW: "Danh sách {0}",
        TITLE_CREATE_VIEW: "Thêm mới {0}",
        TITLE_UPDATE_VIEW: "Cập nhật thông tin {0}",
        TITLE_DETAIL_VIEW: "Xem chi tiết thông tin {0}",
        BASIC_INFO: "Thông tin {0}",
        SEARCH_TEXT: "Tìm kiếm theo tên {0}",
        ENTER_SEARCH_TEXT: "Nhập tên {0}",

        CODE: "Mã {0}",
        FIRST_NAME: "Tên",
        LAST_NAME: "Họ",
        ENTER_FIRST_NAME: "Nhập tên",
        ENTER_LAST_NAME: "Nhập họ",
        FULL_NAME: "Họ và tên",
        GENDER_MALE: "Nam",
        GENDER_FEMALE: "Nữ",
        ENTER_NAME: "Nhập họ và tên",
        PHONE_NUMBER: "Số điện thoại",
        ENTER_PHONE_NUMBER: "Nhập số điện thoại",
        EMAIL: "Email",
        ENTER_EMAIL: "Nhập email",
        BIRTHDAY: "Ngày sinh",
        ROLE: "Vai trò",
        SELECT_ROLE: "Chọn vai trò",
        SELECT_BIRTHDAY: "Chọn ngày sinh",
        GENDER: "Giới tính",
        SELECT_GENDER: "Chọn giới tính",
        STAFF_PERMISSION: "Vai trò {0}",
        SELECT_STAFF_PERMISSION: "Chọn vai trò {0}",
        WORK_GROUPS: "{0} làm việc",
        SELECT_WORK_GROUPS: "Chọn {0} làm việc",
        WORK_GROUPS_ALREADY_EXIST: "{0} làm việc này đã tồn tại. vui lòng chọn {1} làm việc khác",
        MANAGER_GROUP: "Quản lý {0}",
        GROUP_DEFAULT: "{0} mặc định",
        SELECT_GROUP_DEFAULT: "Chọn làm {0} mặc định",
        STAFF_POSITION: "Chức danh {0}",
        SELECT_STAFF_POSITION: "Chọn chức danh {0}",
        PLEASE_CHOOSE_GROUP_DEFAULT: "Vui lòng chọn {0} mặc định",
        SELECTED_GROUP_WILL_BE_DEFAULT_ONE: "{0} được chọn sẽ là {1} mặc định",
        INVITATION_STAFF: "Mời {0}",
        CREATE_INVITATION: "Tạo lời mời",
        SEND_SUCCESS: "Gửi lời mời thành công!",
        CONFIRM_DELETE_USER_GROUP: "Bạn có thực sự muốn xóa?",
        DELETE_USER_GROUP_SUCCESS: "Đã xóa thành công!",
        UPDATE_USER_GROUP_SUCCESS: "Cập nhật thành công!",
        CREATE_USER_GROUP_SUCCESS: "Thêm mới thành công!",
        UPDATE_STAFF_ROLE_SUCCESS: "Cập nhật vai trò {0} thành công!",
        NOTE_DELETE_ALL_SERVICE: "{0} sẽ bị xóa ra khỏi tất cả các dịch vụ",
        DELETE_ALL_SERVICE: "Xóa khỏi tất cả dịch vụ",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa {0} này?",
        CONFIRM_RESEND: "Bạn có thực sự muốn gửi lại lời mời này?",
        CREATE_SUCCESS: "Tạo {0} mới thành công!",
        UPDATE_SUCCESS: "Cập nhật thông tin {0} thành công!",
        DELETE_SUCCESS: "Xóa {0} thành công!",
        RESEND_SUCCESS: "Gửi lại lời mời đã thành công!",
        ID_CARD_NO: "Số CMND/CCCD",
        ID_CARD_ISSUED_DATE: "Ngày cấp",
        ID_CARD_ISSUED_PLACE: "Nơi cấp",
        ENTER_ID_CARD_NO: "Nhập số CMND/CCCD",
        SELECT_ID_CARD_ISSUED_DATE: "Chọn ngày cấp",
        ENTER_ID_CARD_ISSUED_PLACE: "Nhập nơi cấp",
        SOCIAL_INSURANCE_CODE: "Số bảo hiểm xã hội",
        ENTER_SOCIAL_INSURANCE_CODE: "Nhập số bảo hiểm xã hội",
        SELECT_EMPLOYMENT_DATE: "Chọn ngày vào làm",
        EMPLOYMENT_DATE: "Ngày vào làm",
        TERMINATIONT_DATE: "Ngày nghỉ làm",
        ENTER_TERMINATIONT_DATE: "Chọn ngày nghỉ làm",
        CHANGE_ROLE: "{0} này sẽ mất chức vụ quản lý {1} trong {2} làm việc nữa. Bạn có chắc chắn muốn cập nhật không?",
        WRONG_SOCIAL_INSURANCE_CODE_FORMAT: "Sai định dạng số bảo hiểm xã hội",
        WRONG_PASSPORT_NO_CODE_FORMAT: "Sai định dạng số hộ chiếu",
        NOTE_SOCIAL_INSURANCE_CODE: "(Độ dài số bảo hiểm xã hội tối thiểu 10 số)",
        WRONG_ID_CARD_NO_FORMAT: "Sai định dạng số CMND/CCCD",
        NOTE_ID_CARD_NO: "(Độ dài số CMND/CCCD tối thiểu 9 số)",

        PASSPORT_ISSUING_COUNTRY: "Nơi cấp hộ chiếu",
        PASSPORT_EXPDATE: "Hạn hộ chiếu",
        PASSPORT_NUMBER: "Số hộ chiếu",
        SELECT_PASSPORT_ISSUING_COUNTRY: "Chọn nơi cấp hộ chiếu",
        ENTER_PASSPORT_EXPDATE: "Chọn hạn hộ chiếu",
        ENTER_PASSPORT_NUMBER: "Nhập số hộ chiếu",
        NATIONALITY: "Quốc tịch",
        SELECT_NATIONALITY: "Chọn quốc tịch",
    },

    Profile: {
        PROFILE: "Hồ sơ",
        BASIC_INFO: "Thông tin cơ bản",
        PERSONAL_INFORMATION: "Thông tin cá nhân",
        USER_CONTACT: "Thông tin liên hệ",
        UPDATE_PASSWORD: "Cập nhật mật khẩu",
        UPDATE_EMAIL: "Cập nhật email",
        SECURITY: "Bảo mật",
        CHANGE_PROFILE_SUCCESS: "Cập nhật thông tin cá nhân thành công!",

        EMAIL: "Email",
        ENTER_EMAIL: "Nhập email",
        NEW_EMAIL: "Email mới",
        ENTER_NEW_EMAIL: "Nhập email mới",
        GET_OTP_CODE: "Lấy mã OTP",
        COMPLETE: "Hoàn thành",
        SEND_TO: "Lấy mã lại",
        OTP_CODE: "Mã OTP",
        ENTER_OTP_CODE: "Nhập mã OTP",

        PASSWORD: "Mật khẩu",
        OLD_PASSWORD: "Mật khẩu cũ",
        NEW_PASSWORD: "Mật khẩu mới",
        CONFIRM_NEW_PASSWORD: "Xác nhận mật khẩu mới",
        ENTER_OLD_PASSWORD: "Nhập mật khẩu cũ",
        ENTER_NEW_PASSWORD: "Nhập mật khẩu mới",
        ENTER_CONFIRM_NEW_PASSWORD: "Nhập xác nhận mật khẩu mới",
        CONFIRM_NEW_PASSWORD_VALIDATE: "Nhập xác nhận mật khẩu không khớp",
        DEVICE_VERIFICATION: "Xác minh thiết bị",
        CONFIRM_DEVICE_VERIFICATION_EMAIL: "Mã xác minh sẽ được gửi tới email {0}. Vui lòng nhập mã xác minh vào ô bên dưới",
        CONFIRM_DEVICE_VERIFICATION_PASSWORD:
            "Mã xác thực thay đổi mật khẩu đã được gửi tới email {0} của bạn. Vui lòng nhập mã xác minh vào ô bên dưới",
        CHANGE_EMAIL_SUCCESS: "Cập nhập email thành công!",
        CHANGE_PASSWORD_SUCCESS: "Cập nhật mật khẩu thành công!",
        CHANGE_AVTAR_SUCCESS: "Cập nhật ảnh đại diện thành công!",

        COUNTRY: "Quốc gia",
        SELECT_COUNTRY: "Chọn quốc gia",
        CITY_NAME: "Thành phố",
        ENTER_CITY_NAME: "Nhập tên thành phố",
        PROVINCE_STATE_NAME: "Tỉnh/Tiểu bang",
        ENTER_PROVINCE_STATE_NAME: "Nhập tên tỉnh/tiểu bang",
        DISTRICT_NAME: "Quận/Huyện",
        ENTER_DISTRICT_NAME: "Nhập tên quận/huyện",
        WARD_NAME: "Phường/Xã",
        ENTER_WARD_NAME: "Nhập tên phường/xã",
        ADDRESS_LINE: "Địa chỉ",
        ENTER_ADDRESS_LINE: "Nhập địa chỉ",
        ADDRESS_LINE2: "Địa chỉ 2",
        ENTER_ADDRESS_LINE2: "Nhập địa chỉ 2",
        POSTAL_CODE: "Mã Postal",
        ENTER_POSTAL_CODE: "Nhập mã postal",
        LIST_USER_CONTACT: "Danh sách thông tin liên hệ",
        UPDATE_USER_CONTACT: "Cập nhật thông tin liên hệ",
        CREATE_USER_CONTACT: "Thêm mới thông tin liên hệ",
        UPDATE_USER_CONTACT_SUCCESS: "Cập nhật thông tin liên hệ thành công!",
        CREATE_USER_CONTACT_SUCCESS: "Thêm mới thông tin liên hệ thành công!",
        CONFIRM_UPDATE_CONTACT_DEFAULT: "Bạn có thực sự muốn thông tin liên hệ này được đặt làm mặc định không?",
        UPDATE_SUCCESS: "Cập nhật thành công!",
        CONFIRM_DELETE_CONTACT: "Bạn có thực sự muốn xóa thông tin liên hệ này không?",
        DELETE_USER_CONTACT_SUCCESS: "Thông tin liên hệ đã được xóa thành công!",
        UPDATE_ADDRESS_SUCCESS: "Cập nhật địa chỉ thành công!",
        CREATE_ADDRESS_SUCCESS: "Thêm mới địa chỉ thành công!",
        ADDRESS_INFO: "Thông tin địa chỉ",
    },

    TwoFactorAuth: {
        AUTHENTICATION: "Chứng thực",
        TITLE: "Xác thực hai yếu tố",
        CONTENT_1: "Xác thực hai yếu tố tăng cường tính bảo mật cho tài khoản của bạn.",
        CONTENT_2: "Tài khoản của bạn hiện chưa được kích hoạt xác thực hai yếu tố.",
        BTN_ENROLL_TFA: "Kích hoạt xác thực",
        CONTENT_SCAN_IMAGE: "Quét hình ảnh này bằng ứng dụng xác thực (app Authentication) của bạn:",
        OR_ENTER_THE_SECRET: "Hoặc nhập mã secret:",
        AND_ENTER_PASSCODE: "Và nhập mật mã hiển thị trong ứng dụng:",
        PASS_CODE: "Mật mã",
        ENTER_PASS_CODE: "Nhập mật mã",
        AUTHENTICATED: "Đã kích hoạt",
        UN_AUTHENTICATED: "Chưa kích hoạt",

        VERIFY: "Xác minh",
        VERIFY_TFA_SUCCESS: "Bạn đã kích hoạt xác thực hai yếu tố thành công!",
        CONFIRM_VERIFY_TFA: "Bạn chắc chắn muốn kích hoạt xác thực hai yếu tố?",

        BTN_DISABLE_TFA: "Tắt kích hoạt xác thực",
        CONTENT_DISABLE_TFA: "Bạn có thể tắt xác thực hai yếu tố nếu cần.",
        CONFIRM_DISABLE_TFA: "Bạn chắc chắn muốn tắt kích hoạt xác thực hai yếu tố?",
        DISABLE_TFA_SUCCESS: "Bạn đã tắt kích hoạt xác thực hai yếu tố thành công!",

        BTN_RESET_CODE: "Đặt lại mã",
        CONTENT_RESET_CODE: "Nếu bạn làm mất mã hoặc đã sử dụng nó để đăng nhập, bạn có thể đặt lại mã này tại đây.",
        RESET_CODE_SUCCESS: "Bạn đã đặt lại mã thành công!",
        CONFIRM_RESET_CODE: "Bạn chắc chắn muốn đặt lại mã",
    },

    INVITATION: {
        EMAIL: "Email",
        FULL_NAME: "Họ và tên",
        INVITING_TIME: "Thời gian mời",
        RESOURCE_NAME: "Khoá học",
        CONFIRM_DELETE: "Bạn có thực sự muốn xóa lời mời này?",
        DELETE_INVITATION_SUCCESS: "Xóa lời mời thành công",
        INVITATION_EXPIRED: "Lời mời này đã hết hạn",
        CONFIRM_ACCEPT: "Bạn chắc chắn muốn chấp thuận lời mời này?",
        CONFIRM_DECLINE: "Bạn chắc chắn muốn từ chối lời mời này?",
        CONFIRM_RESEND: "Bạn thực sự muốn gửi lại lời mời này?",
        RESEND_SUCCESS: "Bạn đã gửi lại lời mời thành công",
        ACCEPT_SUCCESS: "Bạn đã chấp thuận lời mời thành công",
        DECLINE_SUCCESS: "Bạn đã từ chối lời mời thành công",
        VALID_FROM: "Từ ngày",
        VALID_TO: "Đến ngày",
        CONTENT_INVITING_1: "Bạn được mời sử dụng khoá học {0} tại {1}",
        CONTENT_INVITING_2: "Bạn được mời sử dụng dịch vụ {0}",
        CONTENT_INVITING_3: "Bạn được mời tham gia tổ chức {0}",
        WITH_ROLE: " với vai trò {0}",
        MESSAGE: "Lời nhắn",
        ENTER_MESSAGE: "Nhập lời nhắn",
        NOTE_MESSAGE_INVITATION: "Thông báo này sẽ được bao gồm trong email chào mừng",
        NOTE_EMAIL_INVITATION: "Thêm từng email hoặc dán danh sách",

        SEND_INVITATION: "Gửi lời mời",
        ACCOUNT_SETTINGS: "Cài đặt tài khoản",
        ROLE: "Phân quyền",
        POLICY: "Chế độ công tác",
        SELECT_POLICY: "Chọn chế độ công tác",
        WORKFLOW: "Quy trình phê duyệt",
        SELECT_WORKFLOW: "Chọn quy trình phê duyệt",
        BUDGET: "Gói ngân sách",
        SELECT_BUDGET: "Chọn gói ngân sách",
        NOTE_EMAIL: "Thêm từng email hoặc dán danh sách",
        REQUIRED_EMAIL: "Vui lòng thêm email",

        COPY_INVITATION_URL: "Sao chép đường dẫn lời mời",
        RESEND_INVITATION: "Gửi lại lời mời",
    },

    CODE_NAME: {
        BASIC_INFO: "Thông tin danh mục",
        SEARCH_TEXT: "Tìm kiếm theo tên",
        CODE_NAME_DETAIL: "Chi tiết danh mục",
        PARENT_GROUP_CODE: "000000",
        PARENT_GROUP: "Danh mục cha",

        CODE: "Mã",
        NAME: "Tên",
        SHORT_NAME: "Tên viết tắt",
        ENTER_CODE: "Nhập mã",
        ENTER_NAME: "Nhập tên",
        ENTER_SHORT_NAME: "Nhập tên viết tắt",
        ORGANIZATION_APPLIES: "Tổ chức áp dụng",
        SELECT_ORGANIZATION_APPLIES: "Chọn tổ chức",
        APPLY_SYSTEM: "Áp dụng trên toàn hệ thống",

        CODE_GROUP: "Mã nhóm danh mục",
        ENTER_CODE_GROUP: "Nhập mã nhóm danh mục",
        NAME_GROUP: "Tên nhóm danh mục",
        ENTER_NAME_GROUP: "Nhập tên nhóm danh mục",
        CONFIRM_DELETE: "Bạn chắc chắn muốn xóa danh mục này?",
        DELETE_SUCCESS: "Danh mục đã được xóa thành công",
        CREATE_SUCCESS: "Tạo mới danh mục thành công",
        UPDATE_SUCCESS: "Cập nhật thông tin danh mục thành công",
    },

    WORKER_NODE: {
        HOST_NAME: "Host name",
        CLEANUP_NODE: "Cleanup node",
        LAUNCH_TIME: "Launch time",
        TERMINATED_TIME: "Terminated time",
        EPOCH_TIME: "Epoch time",
        NODE_TYPE: "Node type",
        UPDATE_TIME: "Update time",
        CREATE_TIME: "Create time",
        CONFIRM_UPDATE: "Bạn chắc chắn muốn cập nhật worker node này",
        UPDATE_SUCCESS: "Cập nhật thành công",
    },

    USER: {
        ADD_NEW: "Thêm người dùng",
        NO_DATA_USER: "Hiện không có người dùng nào trong hệ thống",
    },

    RESOURCE: {
        BASIC_INFO: "Thông tin nhóm tính năng",
        ADD_NEW: "Thêm tính năng",
        GROUP_NAME: "Tên nhóm tính năng",
        GROUP_CODE: "Mã nhóm tính năng",
        RESOURCE_URI: "Mô-đun URI",
        INPUT_GROUP_NAME: "Nhập tên nhóm tính năng",
        SELECT_GROUP_CODE: "Chọn mã nhóm tính năng",
        INPUT_RESOURCE_URI: "Nhập mô-đun URI (<sevice>/<module>/<feature>)",
        PUBLIC: "Công khai",
        PRIVATE: "Cần chứng thực",
        PRIVATERBAC: "Cần phân quyền",
        ROLE_ACCESS: "Quyền truy cập",
        SELECT_ROLE_ACCESS: "Chọn quyền truy cập",
        ADMIN_FEATURE: "Chức năng cho quản trị",
        DESCRIPTION: "Mô tả",
        INPUT_DESCRIPTION: "Nhập mô tả",
        SERVICE: "Dịch vụ",
        SELECT_SERVICE: "Chọn dịch vụ",
    },

    POLICY: {
        BASIC_INFO: "Thông tin phân quyền",
        ADD_NEW: "Thêm tính năng",
        CODE: "Mã",
        NAME: "Tên",
        INPUT_NAME: "Nhập tên",
        SERVICE: "Dịch vụ",
        SELECT_SERVICE: "Chọn dịch vụ",
        DESCRIPTION: "Mô tả",
        INPUT_DESCRIPTION: "Nhập mô tả",
        APPLICABLE_TARGETS: "Đối tượng áp dụng",
        ROLE: "Vai trò",
        GROUP: "Phòng ban",
        USER: "Người dùng",
        ADD_NEW_TARGET: "Thêm mới đối tượng",
        RESOURCES: "Tính năng",
        SEARCH_TEXT: "Tìm kiếm theo tên",
        ENTER_SEARCH_TEXT: "Nhập tên cần tìm kiếm",
    },
};

export default vi;
